import React from "react";
import styled from "styled-components";
import { Colors } from "@blueprintjs/core";
import { connect } from "react-redux";
import { sizes, getScreenCode } from "app/media";

const Wrapper = styled.div``;

const Header = styled.div`
  display: flex;
  align-items: center;
  padding-left: 20px;
  padding-top: 20px;
  & h5 {
    margin: 0;
    flex: 1;
  }
  & button {
    flex: 0;
  }
`;

const Header2 = styled.div`
  background-color: ${Colors.WHITE};
  display: flex;
  align-items: center;
  padding-right: 20px;
  height: 50px;
  & h5 {
    margin: 0;
    flex: 1;
    order: 0;
  }
  & button {
    flex: 0;
    order: -1;
    min-width: 40px;
    height: 50px;
  }

  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 0 0 rgba(16, 22, 26, 0),
    0 1px 1px rgba(16, 22, 26, 0.2);
`;

const Body = styled.div`
  margin: 20px;
  & form .pt-button {
    margin-right: 10px;
  }
`;

const CloseButton = props => {
  const { onClick } = props;
  return (
    <button
      aria-label="Close"
      className="pt-button pt-icon-small-cross pt-minimal"
      onClick={onClick}
    />
  );
};

const BackButton = props => {
  const { onClick } = props;
  return (
    <button
      aria-label="Back"
      className="pt-button pt-icon-arrow-left pt-minimal"
      onClick={onClick}
    />
  );
};

const Sidebar = props => {
  const { title, children, onClose, screen } = props;
  let header = (
    <Header>
      <h5>{title || "(untitled)"}</h5>
      <CloseButton onClick={onClose} />
    </Header>
  );

  if (screen === sizes.tiny) {
    header = (
      <Header2>
        <h5>{title || "(untitled)"}</h5>
        <BackButton onClick={onClose} />
      </Header2>
    );
  }

  return (
    <Wrapper>
      {header}
      <Body>{children}</Body>
    </Wrapper>
  );
};

const mapScreenState = state => {
  return { screen: getScreenCode(state.responsive) };
};

export default connect(mapScreenState)(Sidebar);



// WEBPACK FOOTER //
// ./src/app/layout/Sidebar.js